export const getApiUrlBrandName = (domain) => {
    let apiUrl = "";
    let brandName = "";
    let oldAdminPanel = false;
    let amendedDomain = domain.replace(/(www\.|member\.|members\.|stg\.|staging\.)/g, "");
    switch (amendedDomain) {
        case "equinoxmarkets.com":
        case "equinox-markets.com":
            apiUrl = "https://api.equinoxmarkets.app";
            brandName = "equinox";
            oldAdminPanel = true;
            break;
        case "360th.net":
        case "360tradehub.com":
        case "tradehub360.com":
        case "360tradehub.net":
        case "tradehub360.net":
            apiUrl = "https://api.360tradehub.app";
            brandName = "360tradehub";
            oldAdminPanel = true;
            break;
        case "antos.io":
        case "antospnc.com":
        case "antospnc.ai":
            apiUrl = "https://api.antospnc.app";
            brandName = "antos";
            oldAdminPanel = true;
            break;
        case "blueoceanfin.com":
        case "blueocex.com":
        case "TradeWithBlueOcean.com":
            apiUrl = "https://admin.blueoceanfin.app/graphql";
            brandName = "blueocean";
            break;
        case "fundamarkets.com":
        case "fundamarkets.net":
            apiUrl = "https://admin.fundamarkets.app/graphql";
            brandName = "funda";
            break;
        case "minosfutures.com":
        case "minosbrokers.com":
        case "minosbrokers.net":
            apiUrl = "https://admin.minosmarkets.app/graphql";
            brandName = "minos";
            break;
        case "cronoscap.com":
        case "cronoscap.net":
            apiUrl = "https://admin.cronoscap.app/graphql";
            brandName = "cronos";
            break;
        case "excotrades.com":
            apiUrl = "https://admin.excotrades.app/graphql";
            brandName = "exco";
            break;
        case "ridgewaymarkets.com":
        case "ridgewaymarkets.net":
            apiUrl = "https://admin.ridgewaymarkets.app/graphql";
            brandName = "ridgeway";
            break;
        case "alliumtrades.com":
            apiUrl = "https://admin.alliumtrades.app/graphql";
            brandName = "alliumtrades";
            break;
        case "qvmarkets.com":
            apiUrl = "https://admin.qvmarkets.app/graphql";
            brandName = "qvmarkets";
            break;
        case "metapromarkets.com":
            apiUrl = "https://admin.metapromarkets.app/graphql";
            brandName = "metapro";
            break;
        case "nextrades.ai":
            apiUrl = "https://admin.nextrades.app/graphql";
            brandName = "nextrades";
            break;
        // default:
        //     apiUrl = "https://admin.blueoceanfin.app/graphql";
        //     brandName = "blueocean";
        //     break;
    }
    return {apiUrl, brandName, oldAdminPanel};
};

export function nFormatter(num, unit) {
    if (!unit) {
        if (num >= 1000000000) {
            return (
                (num / 1000000000)
                    .toLocaleString(undefined, {
                        maximumFractionDigits: 2,
                    })
                    .replace(/\.0$/, "") + "B"
            );
        }
        if (num >= 1000000) {
            return (
                (num / 1000000)
                    .toLocaleString(undefined, {
                        maximumFractionDigits: 2,
                    })
                    .replace(/\.0$/, "") + "M"
            );
        }
        if (num >= 1000) {
            return (
                (num / 1000)
                    .toLocaleString(undefined, {
                        maximumFractionDigits: 2,
                    })
                    .replace(/\.0$/, "") + "K"
            );
        }
        if (num < -1000000000) {
            return (
                "-" +
                (num / -1000000000)
                    .toLocaleString(undefined, {
                        maximumFractionDigits: 2,
                    })
                    .replace(/\.0$/, "") +
                "B"
            );
        }
        if (num < -1000000) {
            return (
                "-" +
                (num / -1000000)
                    .toLocaleString(undefined, {
                        maximumFractionDigits: 2,
                    })
                    .replace(/\.0$/, "") +
                "M"
            );
        }
        if (num < -1000) {
            return (
                "-" +
                (num / -1000)
                    .toLocaleString(undefined, {
                        maximumFractionDigits: 2,
                    })
                    .replace(/\.0$/, "") +
                "K"
            );
        }
    }
    return num.toLocaleString(undefined, {
        maximumFractionDigits: 2,
    });
}
